import { render, staticRenderFns } from "./userMyInforShow.vue?vue&type=template&id=486c2541&scoped=true&"
import script from "./userMyInforShow.vue?vue&type=script&lang=js&"
export * from "./userMyInforShow.vue?vue&type=script&lang=js&"
import style0 from "./userMyInforShow.vue?vue&type=style&index=0&id=486c2541&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c2541",
  null
  
)

export default component.exports